<template>
  <div class="bh-textarea" :class="{ 'disabled': disabled }">
    <textarea
      :class="classes"
      :disabled="disabled"
      ref="text-area"
      :placeholder="placeholder"
      :value="value"
      @input="emitValue"/>
  </div>
</template>

<script>
export default {
  name: 'bh-textarea',
  props: {
    placeholder: {
      type: String,
      default: 'Type your notes'
    },
    classes: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitValue(event) {
      const value = event.target.value
      this.$emit('output', value)
    }
  }
}
</script>

<style scoped>
  textarea {
    resize: none;
    outline: none;
  }
</style>
